import React from 'react';
import PropTypes from 'prop-types';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import CitationCell from '@Components/Results/substances/tables/cells/citation-cell.component';
import DataCell from '@Components/Results/substances/tables/cells/data-cell.component';
import PaureusCell from '@Components/Results/substances/tables/cells/PaureusCell';
import ColoredCell from '@Components/Results/substances/tables/cells/ColoredCell';
import TargetCell from '@Components/Results/substances/tables/cells/TargetCell';
import ParameterCell from '@Components/Results/substances/tables/cells/parameter-cell.component';

const cellContentRenderers = {
  paureus: (value) => <PaureusCell value={value} />,
  targets: (value, metadata) => <TargetCell metadata={metadata} value={value} />,
  citation: (citations, metadata) => <CitationCell metadata={metadata} citations={citations} />,
  citations: (citations, metadata) => <CitationCell metadata={metadata} citations={citations} />,
  parameter: (data, metadata, measurements) => <ParameterCell data={data} measurements={measurements} />,
};

function SubstanceQuantitativeCell({ metadata, header, data = [''], measurements, rowIndex, colIndex }) {
  const contentRenderer = cellContentRenderers[header.id] || ((value) => <DataCell data={value} />);
  const isPxColumn = header.id === 'paureus';

  const renderCell = (style) => (
    <td
      className={`table__cell c-els-table__cell c-els-table__element-cell column-${header.cssid} ${isPxColumn ? 'px-data__container' : ''}`}
      style={style}
      data-testid={`${header.id}-semantic-element-cell`}
      data-row={rowIndex}
      data-col={colIndex}>
      <span className="substance-quantitative-table__cell-content">{contentRenderer(data, metadata, measurements)}</span>
    </td>
  );

  if (isPxColumn) {
    return <ColoredCell value={data}>{renderCell}</ColoredCell>;
  }

  return renderCell();
}

SubstanceQuantitativeCell.propTypes = {
  metadata: MetadataPropTypesShape,
  header: PropTypes.shape({
    id: PropTypes.string.isRequired,
    cssid: PropTypes.string.isRequired,
  }).isRequired,
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.number]),
  measurements: PropTypes.string,
  rowIndex: PropTypes.number.isRequired,
  colIndex: PropTypes.number.isRequired,
};

export default SubstanceQuantitativeCell;
